// extracted by mini-css-extract-plugin
module.exports = {"list":"fullTab_list__2w0eU","list_active":"fullTab_list_active__2q0xq"};